import { render, staticRenderFns } from "./MeetingsSidebar.vue?vue&type=template&id=166435e5"
import script from "./MeetingsSidebar.vue?vue&type=script&lang=js"
export * from "./MeetingsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports